<template>
  <div>
    <div class="pa-5 bg-white">
      <v-tabs v-model="tab" grow>
        <v-tab href="#detail" class="subtitle-1 tab-live px-12 uppercast-unset"
          >Company Detail</v-tab
        >
        <v-tab href="#access" class="subtitle-1 tab-live px-12 uppercast-unset"
          >Company Access</v-tab
        >
        <v-tab href="#tabbars" class="subtitle-1 tab-live px-12 uppercast-unset"
          >Company Tabbars</v-tab
        >
        <v-tab href="#tools" class="subtitle-1 tab-live px-12 uppercast-unset"
          >Marketing Tools</v-tab
        >
      </v-tabs>
    </div>

    <v-tabs-items v-model="tab">
      <v-tab-item value="detail">
        <div class="px-5 pt-2 pb-7">
          <warnningComponent
            :textInfo.sync="textWarning"
            :typestatus.sync="typeWarning"
            :alert.sync="showWarnnig"
          ></warnningComponent>
          <v-row>
            <v-col>
              <h3>Company Detail</h3>
            </v-col>
            <v-col class="text-right">
              <v-tooltip class="float-right" top>
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-switch
                      class="float-right"
                      v-model="company_active"
                      @change="changeActive()"
                      inset
                    ></v-switch>
                  </div>
                </template>
                <span v-if="company_active">Click to Suspend</span>
                <span v-else>Click to Activate</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
        <div>
          <companyDetail :id.sync="id_company"></companyDetail>
        </div>
      </v-tab-item>
      <v-tab-item value="access">
        <div class="px-5 pt-2 pb-7">
          <h3>Company Access</h3>
        </div>
        <div>
          <companyAccess :id.sync="id_company"></companyAccess>
        </div>
      </v-tab-item>
      <v-tab-item value="tabbars">
        <div class="px-5 pt-2 pb-7">
          <h3>Company Tabbars</h3>
        </div>
        <div>
          <companyTabbars :id.sync="id_company"></companyTabbars>
        </div>
      </v-tab-item>
      <v-tab-item value="tools">
        <div>
          <marketingTools :id.sync="id_company"></marketingTools>
        </div>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { activeCompany } from "@/service/company/company";
import companyDetail from "@/views/company/company_detail.vue";
import companyAccess from "@/views/company/company_access.vue";
import companyTabbars from "@/views/company/company_tabbars.vue";
import marketingTools from '@/views/company/marketingTools.vue';
import warnningComponent from "@/components/warningAlert.vue";
export default {
  components: {
    companyAccess,
    companyTabbars,
    companyDetail,
    marketingTools,
    warnningComponent,
  },
  data() {
    return {
      tab: "detail",
      id_company: this.$route.query.id,
      company_active: this.$route.query.active,
      textWarning: "",
      typeWarning: "",
      showWarnnig: false,
    };
  },
  methods: {
    // async initialize() {
    //   this.id_company = this.$route.query.id;
    //   this.company_active = this.$route.query.active;
    // },
    async changeActive() {
      let result = await activeCompany({
        id: this.id_company,
        active: this.company_active,
      });
      let text = result.active ? "Activate success" : "Suspend success";
      this.warnnig(text, "success");
    },
    warnnig(text, type) {
      (this.textWarning = text), (this.typeWarning = type), (this.showWarnnig = true);
      setInterval(() => {
        this.showWarnnig = false;
        this.loading = false;
      }, 3000);
    },
  },
  // async beforeMount() {
  //   await this.initialize();
  // },
};
</script>

<style scoped lang="scss">
.bg-white {
  background: #fff;
}

.v-tabs--grow > .v-tabs-bar .v-tab {
  flex: none;
}

.tab-live {
  border-radius: 10px 10px 0 0;
  background: rgba(0, 0, 0, 0.04);
  border: 1px solid #e7e7e7;
  border-bottom: 0;
  box-shadow: 0;
}

.v-tab--active {
  background: #fff !important;
  color: #009bde;
  border-bottom: 0;
}

.uppercast-unset {
  text-transform: unset;
}
</style>
